import React from "react";

interface CheckProps {
  size?: number;
  color?: string;
  className?: string;
}

const Check = ({ size, color, className }: CheckProps) => {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      strokeWidth="1.5"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color ? color : "#000000"}
      className={className}
    >
      <path
        d="M5 13l4 4L19 7"
        stroke={color ? color : "#06AD86"}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default Check;
